import React from 'react';
import {
  DatePicker, TimePrecision,
} from '@blueprintjs/datetime';
import moment from 'moment';
import MomentLocaleUtils from 'react-day-picker/moment';
import i18n from 'i18n';

interface IDateInputProps {
  className?: string,
  closeOnSelection?: boolean;
  date?: Date | null;
  maxDate?: Date,
  minDate?: Date,
  onChange?: any,
  reverseMonthAndYearMenus?: boolean;
  shortcuts?: boolean;
  timePrecision?: TimePrecision | undefined;
  value: Date,
}

const CDatePicker = (props: IDateInputProps) => {
  const {
    value,
    maxDate,
    ...spreadProps
  } = props;
  return (
    <DatePicker
      maxDate={maxDate || moment(new Date()).add(20, 'year').toDate()}
      value={value ? new Date(value) : undefined}
      locale={i18n.language}
      localeUtils={MomentLocaleUtils}
      {...spreadProps}
    />
  );
};

export default CDatePicker;
